import {FunctionComponent} from "react";
import {Logo} from "../atoms/logo";
import {OrderProcessBar} from "../molecules/orderProcessBar";

export const ChangePageHeader: FunctionComponent = () => (
    <>
        <header className={'flex justify-center mt-4'}>
            <Logo/>
        </header>
    </>
)